import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createScreenerEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackScreenerOpen = (
    source: PosthogTrackingSource,
    screenerId?: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SCREENER_OPEN,
      properties: {
        source,
        ...(screenerId !== undefined && { screenerId }),
      },
    });

  const trackScreenerCreate = (
    source: PosthogTrackingSource,
    screenerId?: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SCREENER_CREATE,
      properties: {
        source,
        ...(screenerId !== undefined && { screenerId }),
      },
    });

  const trackScreenerUpdate = (
    source: PosthogTrackingSource,
    screenerId?: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SCREENER_UPDATE,
      properties: {
        source,
        ...(screenerId !== undefined && { screenerId }),
      },
    });

  const trackScreenerTabSelected = (
    source: PosthogTrackingSource,
    type: string,
    screenerId?: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SCREENER_TAB_SELECTED,
      properties: {
        source,
        type,
        ...(screenerId !== undefined && { screenerId }),
      },
    });

  return {
    trackScreenerOpen,
    trackScreenerCreate,
    trackScreenerUpdate,
    trackScreenerTabSelected,
  };
};
